import request from "@/utils/h5Request.js";


// 获取用户信息
export function getSchoolStudentInfo() {
    return request({
        url: `/system/student/getSchoolStudentInfo`,
        method: 'get',
    })
}

// 订单列表--立即支付
export function payOrder(orderId) {
    return request({
        url: `/system/order/afreshQrCode?orderId=${orderId}`,
        method: 'post',
    })
}

// 查看协议列表
export function findAgreeList(orderId) {
    return request({
        url: `/system/order/protocolList?orderId=${orderId}`,
        method: 'post',
    })
}

// 创建订单
export function createOrderCode(productId) {
    return request({
        url: `/system/order/createOrder?productId=${productId}`,
        method: 'post',
    })
}

// 查询收款二维码
export function getPayCode(receiveId) {
    return request({
        url: `/system/order/queryChinaPaybyId?receiveId=${receiveId}`,
        method: 'post',
    })
}

// 支付状态刷新
export function refreshPayStatus(receiveId) {
    return request({
        url: `/system/order/getReceiveStatus?receiveId=${receiveId}`,
        method: 'post',
        hideLoading: true
    })
}
// 获取订单列表
export function findOrderList(data) {
    return request({
        url: `/system/order/orderList?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        method: 'post',
        data
    })
}
// 获取课程详情
export function findCourseDetail(id) {
    return request({
        url: `/system/sales/productDetail?id=${id}`,
        method: 'get',
    })
}
// 课程列表查询
export function findKcInfo(id) {
    return request({
        url: `/system/sales/courseList?id=${id}`,
        method: 'get',
    })
}

// 检查复训
export function checkRetrain(orderId) {
    return request({
        url: `/system/order/repeatTrain/check?orderId=${orderId}`,
        method: 'post',
    })
}

// 申请复训
export function requestRetrain(params) {
    return request({
        url: `/system/order/repeatTrain/apply`,
        method: 'post',
        params
    })
}
// 订单付款记录列表
export function findPayRecordList(orderId) {
    return request({
        url: `/system/order/paymentList?orderId=${orderId}`,
        method: 'post',
    })
}
// 提交退费申请
export function submitRefund(data) {
    return request({
        url: `/system/order/refundApply`,
        method: 'post',
        data
    })
}

// 检查是否已实名
export function checkRealName() {
    return request({
        url: `/system/order/checkRealNameAuth`,
        method: 'post',
    })
}

// 实名认证
export function exeReal(params) {
    return request({
        url: `/system/order/realNameAuthentication`,
        method: 'post',
        params
    })
}

// 签署协议/查看协议
export function agreeOpera(id) {
    return request({
        url: `/system/order/protocolDetail?id=${id}`,
        method: 'post',
    })
}

